
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Home } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import ProgrammeSetupTab from "./loyalty-programme/ProgrammeSetupTab";
import PointsLedgerTab from "./loyalty-programme/PointsLedgerTab";
import RedemptionRulesTab from "./loyalty-programme/RedemptionRulesTab";
import MemberTieringTab from "./loyalty-programme/MemberTieringTab";
import MemberInsightReportTab from "./loyalty-programme/MemberInsightReportTab";

const LoyaltyProgramme = () => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Loyalty Programme</h1>
          <p className="text-muted-foreground">
            Create and manage your customer loyalty program, points, rewards, and tiers.
          </p>
        </div>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Link to="/dashboard/" className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-muted">
                <Home className="h-5 w-5" />
              </Link>
            </TooltipTrigger>
            <TooltipContent>
              <p>Home</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <Card>
        <Tabs defaultValue="programme-setup" className="w-full">
          <TabsList className="grid grid-cols-5 w-full">
            <TabsTrigger value="programme-setup">Programme Setup</TabsTrigger>
            <TabsTrigger value="points-ledger">Points Ledger</TabsTrigger>
            <TabsTrigger value="redemption-rules">Redemption Rules</TabsTrigger>
            <TabsTrigger value="member-tiering">Member Tiering</TabsTrigger>
            <TabsTrigger value="member-insight">Member Insight Report</TabsTrigger>
          </TabsList>
          
          <TabsContent value="programme-setup" className="p-4">
            <ProgrammeSetupTab />
          </TabsContent>
          
          <TabsContent value="points-ledger" className="p-4">
            <PointsLedgerTab />
          </TabsContent>
          
          <TabsContent value="redemption-rules" className="p-4">
            <RedemptionRulesTab />
          </TabsContent>
          
          <TabsContent value="member-tiering" className="p-4">
            <MemberTieringTab />
          </TabsContent>
          
          <TabsContent value="member-insight" className="p-4">
            <MemberInsightReportTab />
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  );
};

export default LoyaltyProgramme;
